import { useState, useEffect } from "react";
import {
    Box,
    Container,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Button,
    Card,
    Stack,
} from "@mui/material";
import {
    ExpandMore as ExpandMoreIcon,
    GetApp as DownloadIcon,
} from "@mui/icons-material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DefaultNavbar from "../../components/TopNavBar/DefaultNavBar";

function ProjectRequirements() {
    const [jsonData, setJsonData] = useState([]);
    const [expanded, setExpanded] = useState('');

    useEffect(() => {
        // Import the JSON file
        import('../../assets/RCAjsonData/RCA15_All_Docs_Full_Derived_Object_DOCS-MN-CAP-CNPS-REQ_export_3-24-2025_v2.json')
            .then(data => {
                setJsonData(data.default);
            })
            .catch(error => console.error('Error loading JSON:', error));
    }, []);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const filterDataByType = (type) => {
        return jsonData.filter(item => item.type === type).map(item => item.fields);
    };

    const downloadPDF = (type) => {
        // In React, files in the public directory are served from the root URL
        const pdfUrl = `/pdfs/RCA15-Mission_Scenario_${type}.pdf`;
        
        // Using fetch to check if the file exists and handle it as a blob
        fetch(pdfUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('PDF not found');
                }
                return response.blob();
            })
            .then(blob => {
                // Create a blob URL and trigger download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `RCA15-Mission_Scenario_${type}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url); // Clean up the blob URL
            })
            .catch(error => {
                console.error('Error downloading PDF:', error);
                alert('Error downloading PDF. Please try again.');
            });
    };

    const renderSection = (title, type, expanded, onChange) => {
        const sectionData = filterDataByType(type);
        
        return (
            <Accordion 
                expanded={expanded === title.toLowerCase()} 
                onChange={onChange(title.toLowerCase())}
                TransitionProps={{ timeout: 0 }}
                sx={{
                    '&:before': {
                        display: 'none',
                    },
                    boxShadow: 'none',
                    '&:not(:last-child)': {
                        borderBottom: 0,
                    },
                    '&:first-of-type': {
                        borderTopLeftRadius: '0.5rem',
                        borderTopRightRadius: '0.5rem',
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: '0.5rem',
                        borderBottomRightRadius: '0.5rem',
                    },
                    '& .MuiAccordionDetails-root': {
                        padding: '16px',
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{color: "text.main"}}/>}
                    sx={{
                        backgroundColor: "navy.main",
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <MDTypography variant="h5">{title} ({sectionData.length})</MDTypography>
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={(e) => {
                                e.stopPropagation();
                                downloadPDF(type);
                            }}
                            sx={{
                                mx: 2,
                            }}
                        >
                            Download PDF
                        </Button>
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor: "navy.main"}}>
                    <Stack spacing={2}>
                        {sectionData.map((item, index) => (
                            <Card 
                                key={index}
                                sx={{
                                    backgroundColor: "slate_gray.main",
                                    p: 2,
                                    boxShadow: 'none',
                                }}
                            >
                                <MDTypography variant="h6" gutterBottom sx={{color: "dark_teal.main"}}>
                                    {item.name}
                                </MDTypography>
                                <MDTypography variant="body2" sx={{color: "black.main"}}>
                                    {item.description}
                                </MDTypography>
                            </Card>
                        ))}
                    </Stack>
                </AccordionDetails>
            </Accordion>
        );
    };

    return (
        <DashboardLayout>
            <DefaultNavbar />
            <MDBox py={3}>
                <Container maxWidth="xl">
                    <MDBox mb={3} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <MDTypography variant="h4">All Decomposed Objects</MDTypography>
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                        >
                            Download All
                        </Button>
                    </MDBox>
                    
                    <Stack spacing={2}>
                        {renderSection('Mission Needs', 'MN', expanded, handleAccordionChange)}
                        {renderSection('Capabilities', 'CAP', expanded, handleAccordionChange)}
                        {renderSection('ConOps', 'CNPS', expanded, handleAccordionChange)}
                        {renderSection('Requirements', 'REQ', expanded, handleAccordionChange)}
                    </Stack>
                </Container>
            </MDBox>
        </DashboardLayout>
    );
}

export default ProjectRequirements; 